import React from "react";
import { Routes, Route } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

import MasterPage from "./AdminManagement/Master/MasterPage";

import DepartmentMaster from "./AdminManagement/Master/DepartmentMaster";
import DesignationMaster from "./AdminManagement/Master/DesignationMaster";
import LeaveTypeMaster from "./AdminManagement/Master/leavetypemaster";

import ShiftMaster from "./AdminManagement/Master/Shiftmaster";


import OtRateMaster from "./AdminManagement/Master/OtRateMaster";
import OTRateList from "./AdminManagement/Master/OTRateList";
import GenerateAllEmployeePayslip from "./AdminManagement/Pages/GenerateAllEmployeePayslip";
import QualificationMaster from "./AdminManagement/Master/QualificationMaster";

import DepartmrentHead from "./AdminManagement/Pages/DepartmrentHead";
import LeaveHistory from "./AdminManagement/Master/LeaveHistory";
import EmployeeAttendanceHistory from "./AdminManagement/Pages/EmployeeAttendanceHistory";
import AttendanceRegisterHistory from "./AdminManagement/Pages/AttendanceRegisterHistory";
import DutyRoasterHistory from "./AdminManagement/Pages/DutyRoasterHistory";
import SalaryHeadForm from "./AdminManagement/Master/SalaryHeadForm";
import SalarySlipHeadList from "./AdminManagement/Master/SalarySlipHeadList";
import PaySlipHistory from "./AdminManagement/Master/PaySlipHistory";



import GeneratePaySlip from "./AdminManagement/Pages/GeneratePaySlip";
import PaySlipGenerateEmployeeList from "./AdminManagement/Pages/PaySlipGenerateEmployeeList";
import ReminderPage from "./AdminManagement/Pages/ReminderPage";
import ShiftManagement from "./AdminManagement/Pages/ShiftManagement";
import LeaveAllocationForm from "./AdminManagement/Pages/LeaveAllocationForm";
import LeaveAllocationList from "./AdminManagement/Pages/LeaveAllocationList";

import AdminLogin from "./AdminManagement/Pages/AdminLogin";
import ActivityHistory from "./AdminManagement/Pages/ActivityHistory";

import EmployeeMaster from "./AdminManagement/Pages/EmployeeMaster";

import AttendanceSignIn from "./AdminManagement/Pages/AttendanceSignIn";
import ChangePassword from "./AdminManagement/Pages/ChangePassword";



import EmployeeAttendanceRequest from "./EmployeeManagement/Pages/EmployeeAttendanceRequest";
import RMAttendanceRequestApproval from "./EmployeeManagement/Pages/RMAttendanceRequestApproval";
import HRApprovalAttendaceReq from "./EmployeeManagement/Pages/HRApprovalAttendaceReq";
import EmployeeShiftTime from "./EmployeeManagement/Pages/EmployeeShiftTime";
import EmployeeLeaveDetails from "./EmployeeManagement/Pages/EmployeeLeaveDetails";
import EmployeeAttendance from "./EmployeeManagement/Pages/EmployeeAttendance";
import EmployeePayslipView from "./EmployeeManagement/Pages/EmployeePayslipView";
import EmployeeDashboard from "./EmployeeManagement/Pages/EmployeeDashboard";
import UserProfile from "./EmployeeManagement/Pages/UserProfile";
import EmployeeHome from "./EmployeeManagement/Pages/EmployeeHome";
import EmployeeCornerSidebar from "./EmployeeManagement/Pages/EmployeeCornerSidebar";
import EmployeeUserIdCreated from "./EmployeeManagement/Pages/EmployeeUserIdCreated";
import EmployeeCalendar from "./EmployeeManagement/Pages/EmployeeCalendar";
import EmployeeLeaveApplication from "./EmployeeManagement/Pages/EmployeeLeaveApplication";




import HomePage from "./GlobalManagement/Pages/HomePage";
import BackButton from "./GlobalManagement/Pages/BackButton";
import ProtectedRoute from "./GlobalManagement/Pages/ProtectedRoute";
import Dashboard from "./GlobalManagement/Pages/Dashboard";
import EditProfile from "./GlobalManagement/Pages/EditProfile";
import AdminManagement from "./AdminManagement/Pages/AdminManagement";




const getToastMessageText = (message) => {
  if (typeof message === "string") return message.trim();
  if (message instanceof Error) return message.message || "Error";
  if (message && typeof message === "object") {
    if (typeof message.message === "string") return message.message.trim();
    return "Something went wrong";
  }
  return String(message || "Error");
};

if (!toast.__errorDedupePatched) {
  const originalError = toast.error.bind(toast);
  toast.error = (message, options = {}) => {
    const normalizedMessage = getToastMessageText(message);
    const providedId = options && typeof options === "object" ? options.id : undefined;
    const dedupeId = providedId || `error:${normalizedMessage.toLowerCase()}`;
    return originalError(normalizedMessage, { ...options, id: dedupeId });
  };
  toast.__errorDedupePatched = true;
}

export default function App(){
  return (
    <>
    <Routes>
      <Route path="/" element={<AdminLogin/>} />
      <Route element={<ProtectedRoute/>}>
        <Route path="/Homepage" element={<HomePage/>} />
        <Route path="/BackButton" element={<BackButton/>} />
        <Route path="/MasterPage" element={<MasterPage/>} />
       
        <Route path="/DepartmentMaster" element={<DepartmentMaster/>} />
        <Route path="/DesignationMaster" element={<DesignationMaster/>} />
        <Route path="/LeaveTypeMaster" element={<LeaveTypeMaster/>} />

        <Route path="/ShiftMaster" element={<ShiftMaster/>} />


        <Route path="/EmployeeMaster" element={<EmployeeMaster/>} />
        <Route path="/Dashboard" element={<Dashboard/>} />
        <Route path="/EditProfile" element={<EditProfile/>} />
        <Route path="/ChangePassword" element={<ChangePassword/>} />
        <Route path="/AdminManagement" element={<AdminManagement/>} />
        <Route path="/LeaveAllocationForm" element={<LeaveAllocationForm/>} />
        <Route path="/LeaveAllocationList" element={<LeaveAllocationList/>} />
        <Route path="/EmployeeDashboard" element={<EmployeeDashboard/>} />
        <Route path="/UserProfile" element={<UserProfile/>} />
        <Route path="/EmployeeHome" element={<EmployeeHome/>} />
        <Route path="/EmployeeCornerSidebar" element={<EmployeeCornerSidebar/>} />
        <Route path="/EmployeeUserIdCreated" element={<EmployeeUserIdCreated/>} />
        <Route path="/EmployeeCalendar" element={<EmployeeCalendar/>} />
        <Route path="/EmployeeLeaveApplication" element={<EmployeeLeaveApplication/>} />
        <Route path="/SalaryHeadForm" element={<SalaryHeadForm/>} />
        <Route path="/SalarySlipHeadList" element={<SalarySlipHeadList/>} />
        <Route path="/PaySlipGenerateEmployeeList" element={<PaySlipGenerateEmployeeList/>} />
        <Route path="/GeneratePaySlip" element={<GeneratePaySlip/>} />
        <Route path="/PaySlipHistory" element={<PaySlipHistory/>} />
        <Route path="/ReminderPage" element={<ReminderPage/>} />
        <Route path="/ShiftManagement" element={<ShiftManagement/>} />
        <Route path="/EmployeeLeaveDetails" element={<EmployeeLeaveDetails/>} />
        <Route path="/EmployeeAttendance" element={<EmployeeAttendance/>} />
        <Route path="/LeaveHistory" element={<LeaveHistory/>} />
        <Route path="/EmployeeAttendanceHistory" element={<EmployeeAttendanceHistory/>} />
        <Route path="/AttendanceRegisterHistory" element={<AttendanceRegisterHistory/>} />
        <Route path="/DutyRoasterHistory" element={<DutyRoasterHistory/>} />
        <Route path="/EmployeePayslipView" element={<EmployeePayslipView/>} />
        <Route path="/AttendanceSignIn" element={<AttendanceSignIn/>} />
        <Route path="/OtRateMaster" element={<OtRateMaster/>} />
        <Route path="/OTRateList" element={<OTRateList/>} />
        <Route path="/GenerateAllEmployeePayslip" element={<GenerateAllEmployeePayslip/>} />
        <Route path="/QualificationMaster" element={<QualificationMaster/>} />
        <Route path="/EmployeeShiftTime" element={<EmployeeShiftTime/>} />
        <Route path="/DepartmrentHead" element={<DepartmrentHead/>} />
        <Route path="/ActivityHistory" element={<ActivityHistory/>} />
        <Route path="/EmployeeAttendanceRequest" element={<EmployeeAttendanceRequest/>} />
        <Route path="/RMAttendanceRequestApproval" element={<RMAttendanceRequestApproval/>} />
        <Route path="/HRApprovalAttendaceReq" element={<HRApprovalAttendaceReq />} />
      </Route>
 
     </Routes>
      <Toaster
        reverseOrder={false}
        position="top-center"
        toastOptions={{
          style: {
            fontWeight: 600,
            fontSize: "13px",
            fontFamily: "sans-serif",
            maxWidth: "340px",
            width: "100%",
            borderRadius: "4px",
            padding: "6px 12px",
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
          },
          success: {
            icon: (
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#14532d" 
                strokeWidth="2.5" 
                className="w-4 h-4 flex-shrink-0"
                style={{ marginRight: "6px" }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ),
            style: {
              background: "#f0fdf4",
              color: "#14532d",
              border: "1px solid #15803d",
            },
          },
          error: {
            icon: (
              <svg 
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#991b1b" 
                strokeWidth="2.5" 
                className="w-4 h-4 flex-shrink-0"
                style={{ marginRight: "6px" }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            ),
            style: {
              background: "#fef2f2",
              color: "#991b1b",
              border: "1px solid #b91c1c",
            },
          },
        }}
      />
</>
  );
}
